import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgLeaderboardStats',
})
export default class CmgLeaderboardStats extends Vue {}
